import { z } from 'zod/v4';
import { PropertyDataType } from '../../properties/index.js';
export const propertyItemSchema = z.object({
    handle: z.string(),
    label: z.string(),
    value: z.string().nullable(),
    dataType: z.enum(PropertyDataType),
    description: z.string().nullable(),
});
//# sourceMappingURL=property-shape.js.map